import React from "react";

import { Trans, withTranslation } from "react-i18next";
import i18next from "i18next";

import {
  Icon,
  H4,
  Dialog,
  Classes,
  Button,
  Intent,
  Checkbox,
  FormGroup,
  Spinner,
  Callout,
  Card,
  InputGroup,
  Tag,
  Tooltip,
  Popover,
  PopoverInteractionKind,
  MenuItem,
} from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";
import i18n from "../../i18n";

import {
  Cell,
  Column,
  ColumnHeaderCell,
  RowHeaderCell,
  Table2,
} from "@blueprintjs/table";

import { getLoggedUserLevel } from "../auth/Signin";
import {
  authenticatedGetFetch,
  authenticatedPutFetch,
  authenticatedPostFetchWithResult,
  authenticatedDeleteFetch,
} from "../../utils/AuthenticatedFetch";
import { getSetting } from "../Settings/InstallationSettings";
import UserCreator from "./UserCreator";
import UserHistory from "./UserHistory";

class UserList extends React.Component {
  constructor(props) {
    super(props);

    const groups = this.refreshGroups();
    this.state = {
      userListUpdatetime: props.userListUpdatetime,
      updateTableRunning: false,
      dataUser: [],
      delete: {},
      edit: {},
      runningDelete: false,
      runningEdit: false,
      errorDelete: false,
      errorEdit: false,
      loading: false,
      permCode: [],
      codeMinLength: 3,
      codeMaxLength: 7,
      groups,
      pw1: "",
      pw2: "",
      Columns: [],
    };
  }
  refreshGroups() {
    let groups;
    const groupStr = localStorage.getItem("groups");
    if (groupStr) {
      groups = JSON.parse(groupStr);
    } else groups = [];

    return groups;
  }

  updateTable() {
    if (getLoggedUserLevel() > 0) {
      authenticatedGetFetch("/users", (response) => {
        if (localStorage.getItem("perm_superadmin") === "false")
          response.shift(); // hide user thales ?
        this.setState({ dataUser: response });
      });
    }
  }

  componentDidMount() {
    this.updateTable();
    var ConditionalColumns = [];
    if (localStorage.getItem("perm_financial_display") === "true") {
      ConditionalColumns.push(
        <Column
          key={"peruf"}
          id="permFinancial"
          cellRenderer={(rowIndex) => (
            <Cell>
              {this.state.dataUser[rowIndex]["permFinancial"] ? (
                <Icon icon="document" intent="success" />
              ) : (
                <Icon icon="cross" intent="danger" />
              )}
            </Cell>
          )}
          columnHeaderCellRenderer={() => (
            <ColumnHeaderCell
              name={<Trans>access to financial report</Trans>}
            />
          )}
        />
      );
    }
    if (localStorage.getItem("perm_activity_display") === "true") {
      ConditionalColumns.push(
        <Column
          key={"perua"}
          id="permActivity"
          cellRenderer={(rowIndex) => (
            <Cell>
              {this.state.dataUser[rowIndex]["permActivity"] ? (
                <Icon icon="timeline-line-chart" intent="success" />
              ) : (
                <Icon icon="cross" intent="danger" />
              )}
            </Cell>
          )}
          columnHeaderCellRenderer={() => (
            <ColumnHeaderCell name={<Trans>access to activity report</Trans>} />
          )}
        />
      );
    }
    if (localStorage.getItem("perm_SPV_display") === "true") {
      ConditionalColumns.push(
        <Column
          key={"perus"}
          id="permSpv"
          cellRenderer={(rowIndex) => (
            <Cell>
              {this.state.dataUser[rowIndex]["permSpv"] ? (
                <Icon icon="drive-time" intent="success" />
              ) : (
                <Icon icon="cross" intent="danger" />
              )}
            </Cell>
          )}
          columnHeaderCellRenderer={() => (
            <ColumnHeaderCell
              name={<Trans>access to the real time supervision</Trans>}
            />
          )}
        />
      );
    }
    if (
      getSetting("enable bonification") &&
      (localStorage.getItem("perm_bonification") === "true" ||
        localStorage.getItem("perm_superadmin") === "true")
    ) {
      ConditionalColumns.push(
        <Column
          key={"perbonitick"}
          id="permBonitick"
          cellRenderer={(rowIndex) => (
            <Cell>
              {this.state.dataUser[rowIndex]["permBonitick"] ? (
                <Icon icon="tag" intent="success" />
              ) : (
                <Icon icon="cross" intent="danger" />
              )}
            </Cell>
          )}
          columnHeaderCellRenderer={() => (
            <ColumnHeaderCell name={<Trans>access to Bonitick</Trans>} />
          )}
        />
      );
    }
    if (getSetting('enable external access controle', false) === true || localStorage.getItem("perm_superadmin") === "true") {
      ConditionalColumns.push(
        <Column
          key={"perExternAccessControl"}
          id="perExternAccessControl"
          cellRenderer={(rowIndex) => (
            <Cell>
              {this.state.dataUser[rowIndex]["permExternAccessCtrl"] ? (
                <Icon icon="changes" intent="success" />
              ) : (
                <Icon icon="cross" intent="danger" />
              )}
            </Cell>
          )}
          columnHeaderCellRenderer={() => (
            <ColumnHeaderCell
              name={<Trans>access to external access control</Trans>}
            />
          )}
        />
      );
    }
    this.setState({ Columns: ConditionalColumns });
  }

  handleClose = () =>
    this.setState({
      errorDelete: false,
      runningDelete: false,
      runningEdit: false,
      runningPasswordChange: false,
      pw1: "",
      pw2: "",
    });

  handleChangePassword = async () => {
    this.setState({ loading: true }, () => {
      authenticatedPostFetchWithResult(
        "/changeforgottenpwd/" + this.state.passwordChange["id"],
        {
          user: this.state.passwordChange.login,
          data1: this.state.pw1,
          data2: this.state.pw2,
        },
        () => {
          this.setState({
            success: true,
            loading: false,
            errPwdMissmatch: false,
            errPwdSpecial: false,
            errPwdLength: false,
          });
        },
        (error) => {
          this.setState({
            errPwdMissmatch: error.err.includes("new passwords missmatch"),
            errPwdSpecial: error.err.includes(
              "new password not enough special char"
            ),
            errPwdLength: error.err.includes("new password too short"),
            loading: false,
          });
        }
      );
    });
  };

  manageAccessCodeGroupSelection(id) {
    id = parseInt(id, 10);
    let edit = { ...this.state.edit };
    if (!edit.permCode || !edit.permCode.group) {
      edit.permCode = { group: [], codeMinLength: 3, codeMaxLength: 7 };
    }

    const index = edit.permCode.group.findIndex((val) => val === id);
    if (index === -1) {
      edit.permCode.group.push(id);
    } else {
      edit.permCode.group.splice(index, 1);
    }
    if (edit.permCode.group.length === 0) edit.permCode = undefined;

    this.setState({ edit });
  }

  accessCodeGroupIsSelected(id) {
    id = parseInt(id, 10);
    return !(this.state.edit.permCode && this.state.edit.permCode?.group)
      ? false
      : this.state.edit.permCode.group.findIndex((val) => val === id) !== -1;
  }

  getAccesCodeConfig() {
    const groups = [];
    for (const group of Object.keys(this.state.groups)) {
      groups.push(
        <Checkbox
          key={"g"+group?.id}
          label={<span>{this.state.groups[group].label}</span>}
          checked={this.accessCodeGroupIsSelected(group)}
          onChange={(cb) => {
            this.manageAccessCodeGroupSelection(group);
          }}
        />
      );
    }
    if (!this.state.edit.permCode) {
      this.setState({
        edit: {
          ...this.state.edit,
          permCode: { group: [], codeMinLength: 3, codeMaxLength: 7 },
        },
      });
    }
    return (
      <>
        <Callout title={<Trans>Access code length</Trans>}>
          <Select
            items={[3, 4, 5, 7]}
            itemRenderer={(item, { select, modifiers }) => {
              return (
                <MenuItem
                  key={"UL_codeLengthMin" + item}
                  label={item}
                  text={item}
                  disabled={item > this.state.edit.permCode?.codeMaxLength}
                  onClick={(it) => {
                    const usr = { ...this.state.edit };
                    usr.permCode.codeMinLength = item;
                    this.setState({ edit: usr });
                  }}
                />
              );
            }}
          >
            <Button
              text={
                i18n.t("Minimum length") +
                " " +
                this.state.edit.permCode?.codeMinLength
              }
              rightIcon="double-caret-vertical"
            />
          </Select>
          <Select
            items={[3, 4, 5, 7]}
            itemRenderer={(item, { select, modifiers }) => {
              return (
                <MenuItem
                  key={"UL_codeLengthMax" + item}
                  label={item}
                  text={item}
                  disabled={item < this.state.edit.permCode?.codeMinLength}
                  onClick={(it) => {
                    const usr = { ...this.state.edit };
                    usr.permCode.codeMaxLength = item;
                    this.setState({ edit: usr });
                  }}
                />
              );
            }}
          >
            <Button
              text={
                i18n.t("Maximum length") +
                " " +
                this.state.edit.permCode?.codeMaxLength
              }
              rightIcon="double-caret-vertical"
            />
          </Select>
        </Callout>
        <Callout title={<Trans>list of groups</Trans>}>{groups}</Callout>
      </>
    );
  }

  getTableColomn(Columns) {
    const data = [];
    data.push(
      <Column
        id="login"
        cellRenderer={(rowIndex) => (
          <Cell>{this.state.dataUser[rowIndex]["login"]}</Cell>
        )}
        columnHeaderCellRenderer={() => (
          <ColumnHeaderCell name={<Trans>login</Trans>} />
        )}
      />
    );

    data.push(
      <Column
        id="insertiondate"
        cellRenderer={(rowIndex) => (
          <Cell>
            {new Date(
              this.state.dataUser[rowIndex]["insertiondate"]
            ).toLocaleDateString(i18next.language)}
          </Cell>
        )}
        columnHeaderCellRenderer={() => (
          <ColumnHeaderCell name={<Trans>creation date</Trans>} />
        )}
      />
    );

    data.push(Columns);

    data.push(
      <Column
        id="permAdmin"
        cellRenderer={(rowIndex) => (
          <Cell>
            {this.state.dataUser[rowIndex]["isAdmin"] ? (
              <Icon icon="crown" intent="success" />
            ) : (
              <Icon icon="cross" intent="danger" />
            )}
          </Cell>
        )}
        columnHeaderCellRenderer={() => (
          <ColumnHeaderCell name={<Trans>administration permissions</Trans>} />
        )}
      />
    );

    if (getSetting("enable code"))
      data.push(
        <Column
          id="permCode"
          cellRenderer={(rowIndex) => (
            <Cell>
              {this.state.dataUser[rowIndex]["permCode"].length > 0 ? (
                <Icon icon="layout-grid" intent="success" />
              ) : (
                <Icon icon="cross" intent="danger" />
              )}
            </Cell>
          )}
          columnHeaderCellRenderer={() => (
            <ColumnHeaderCell name={<Trans>access code management</Trans>} />
          )}
        />
      );

    data.push(
      <Column
        id="action"
        cellRenderer={(rowIndex) => (
          <Cell>
            <div className="flexbox-center">
              <Tag
                icon="key"
                interactive={true}
                minimal={true}
                onClick={() =>
                  this.setState({
                    passwordChange: this.state.dataUser[rowIndex],
                    runningPasswordChange: true,
                  })
                }
              />

              <Tag
                icon="edit"
                interactive={true}
                minimal={true}
                onClick={() => {
                  this.setState({
                    edit: this.state.dataUser[rowIndex],
                    runningEdit: true,
                    groups: this.refreshGroups(),
                  });
                }}
              />
              {localStorage.getItem("perm_superadmin") === "true" &&
                this.state.dataUser[rowIndex].login !== "thales" && (
                  <Tag
                    icon="trash"
                    intent="danger"
                    minimal={true}
                    interactive={true}
                    onClick={(event, rowData) => {
                      console.log(
                        "DELETE",
                        this.state.dataUser[rowIndex].login
                      );
                      this.setState({
                        delete: this.state.dataUser[rowIndex],
                        runningDelete: true,
                      });
                    }}
                  />
                )}
            </div>
          </Cell>
        )}
        columnHeaderCellRenderer={() => <ColumnHeaderCell />}
      />
    );
    return data;
  }

  getValidEditPayoad() {
    const payload = { ...this.state.edit };
    if (
      this.state.edit.permCode &&
      this.state.edit.permCode.group?.length === 0
    ) {
      payload.permCode = undefined;
    }
    return payload;
  }

  render() {
    const passwordButton = (
      <Tooltip
        content={
          this.state.showPassword ? (
            <Trans>hide password</Trans>
          ) : (
            <Trans>show password</Trans>
          )
        }
      >
        <Button
          icon={this.state.showPassword ? "unlock" : "lock"}
          intent={Intent.WARNING}
          minimal={true}
          onClick={() =>
            this.setState({ showPassword: !this.state.showPassword })
          }
        />
      </Tooltip>
    );

    return (
      <Callout icon="team" title={<Trans>user management</Trans>}>

        {/* DELETE DIALOG */}
        <Dialog
          onClose={this.handleClose}
          isOpen={this.state.runningDelete}
          style={{ transition: "none" }}
        >
          <div className={Classes.DIALOG_BODY}>
            <Trans>delete user</Trans> <b>{this.state.delete.login}</b>
            <Callout hidden={!this.state.errorDelete} intent="danger">
              <Trans>an eror occured, please try again later.</Trans>
            </Callout>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <Trans>this operation is irreversible</Trans>
            <div hidden={!this.state.loading}>
              <Spinner />
            </div>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button
                icon="undo"
                intent={Intent.DANGER}
                disabled={this.state.loading}
                onClick={this.handleClose}
              >
                <Trans>cancel</Trans>
              </Button>
              <Button
                icon="trash"
                loading={this.state.loading}
                onClick={() => {
                  this.setState({ loading: true }, () => {
                    authenticatedDeleteFetch(
                      "/user/" + this.state.delete["id"],
                      null,
                      () => {
                        this.setState({ loading: false }, () => {
                          this.updateTable();
                          this.handleClose();
                        });
                      },
                      () => {
                        this.setState({ errorDelete: true });
                      }
                    );
                  });
                }}
              >
                <Trans>confirm</Trans>
              </Button>
            </div>
          </div>
        </Dialog>

        {/* EDIT DIALOG */}
        <Dialog isOpen={this.state.runningEdit} onClose={this.handleClose} title={<Trans>permissions</Trans>}>
          <div className={Classes.DIALOG_BODY}>
            <H4>
              <Trans>permissions</Trans>
            </H4>
            <FormGroup>
              {localStorage.getItem("perm_financial_display") === "true" && (
                <Checkbox
                  label={
                    <span>
                      <Icon icon="document" />{" "}
                      <Trans>access to financial report</Trans>
                    </span>
                  }
                  checked={this.state.edit.permFinancial}
                  onChange={(cb) => {
                    var user = this.state.edit;
                    user.permFinancial = cb.target.checked;
                    this.setState({ edit: user });
                  }}
                />
              )}
              {localStorage.getItem("perm_activity_display") === "true" && (
                <Checkbox
                  label={
                    <span>
                      <Icon icon="timeline-line-chart" />{" "}
                      <Trans>access to activity report</Trans>
                    </span>
                  }
                  checked={this.state.edit.permActivity}
                  onChange={(cb) => {
                    var user = this.state.edit;
                    user.permActivity = cb.target.checked;
                    this.setState({ edit: user });
                  }}
                />
              )}
              {localStorage.getItem("perm_custom_report_display") === "true" && (
                <Checkbox
                  label={
                    <span>
                      <Icon icon="timeline-bar-chart" />{" "}
                      <Trans>access to custom report</Trans>
                    </span>
                  }
                  checked={this.state.edit.permCustomReport}
                  onChange={(cb) => {
                    var user = this.state.edit;
                    user.permCustomReport = cb.target.checked;
                    this.setState({ edit: user });
                  }}
                />
              )}
              {localStorage.getItem("perm_SPV_display") === "true" && (
                <Checkbox
                  label={
                    <span>
                      <Icon icon="drive-time" />{" "}
                      <Trans>access to the real time supervision</Trans>
                    </span>
                  }
                  checked={this.state.edit.permSpv}
                  onChange={(cb) => {
                    var user = this.state.edit;
                    user.permSpv = cb.target.checked;
                    this.setState({ edit: user });
                  }}
                />
              )}
              {(localStorage.getItem("perm_bonification") === "true" || localStorage.getItem("perm_superadmin") === "true")&& (
                <Checkbox
                  label={
                    <span>
                      <Icon icon="tag" />{" "}
                      <Trans>access to Bonitick</Trans>
                    </span>
                  }
                  checked={this.state.edit.permBonitickpermExternAccessCtrl}
                  onChange={(cb) => {
                    var user = this.state.edit;
                    user.permBonitick = cb.target.checked;
                    this.setState({ edit: user });
                  }}
                />
              )}
              {(getSetting('enable external access controle', false) === true || localStorage.getItem("perm_superadmin") === "true")&& (
                <Checkbox
                  label={
                    <span>
                      <Icon icon="changes" />{" "}
                      <Trans>access to external access control</Trans>
                    </span>
                  }
                  checked={this.state.edit.permExternAccessCtrl}
                  onChange={(cb) => {
                    var user = this.state.edit;
                    user.permExternAccessCtrl = cb.target.checked;
                    this.setState({ edit: user });
                  }}
                />
              )}              
              <Tooltip
                content={
                  <Trans>
                    this user will be able to create other users and to modify
                    their permissions
                  </Trans>
                }
              >
                <Checkbox
                  label={
                    <span>
                      <Icon icon="crown" />{" "}
                      <Trans>administration permissions</Trans>
                    </span>
                  }
                  checked={this.state.edit.isAdmin}
                  onChange={(cb) => {
                    var user = this.state.edit;
                    user.isAdmin = cb.target.checked;
                    this.setState({ edit: user });
                  }}
                />
              </Tooltip>

              {getSetting("enable code") && (
                <>
                  <Popover
                    content={this.getAccesCodeConfig()}
                    placement="bottom"
                    interactionKind={PopoverInteractionKind.HOVER}
                    modifiers={{ arrow: { enabled: true } }}
                  >
                    <Button icon="edit" intent={Intent.NONE}>
                      <Trans>select the group to manage access codes</Trans>
                    </Button>
                  </Popover>
                  <Tag>
                    {this.state.edit.permCode?.group?.length ?? 0}{" "}
                    <Trans>Groups</Trans>
                  </Tag>
                </>
              )}
            </FormGroup>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button
                icon="undo"
                intent={Intent.DANGER}
                disabled={this.state.loading}
                onClick={this.handleClose}
              >
                <Trans>cancel</Trans>
              </Button>
              <Button
                icon="send-to"
                loading={this.state.loading}
                onClick={() =>
                  this.setState({ loading: true }, async () => {
                    authenticatedPutFetch(
                      "/user/" + this.state.edit["id"],
                      this.getValidEditPayoad(),
                      () =>
                        this.setState({ loading: false }, () => {
                          this.updateTable();
                          this.handleClose();
                        }),
                      () => this.setState({ errorEdit: true })
                    );
                  })
                }
              >
                <Trans>confirm</Trans>
              </Button>
            </div>
          </div>
        </Dialog>

        {/* EDIT PASSWORD DIALOG */}
        {this.state.runningPasswordChange ? (
          <Dialog
            onClose={this.handleClose}
            isOpen={this.state.runningPasswordChange}
            style={{ transition: "none" }}
            title={
              <span>
                <Trans>edit password</Trans> <Trans>for user</Trans>{" "}
                <b>{this.state.passwordChange["login"]}</b>
              </span>
            }
          >
            <div className={Classes.DIALOG_BODY}>
              <Card>
                <form>
                  <FormGroup
                    label={<Trans>new password</Trans>}
                    labelFor="password-input"
                  >
                    <InputGroup
                      id="password-input"
                      type={this.state.showPassword ? "text" : "password"}
                      onChange={(ti) => {
                        this.setState({ pw1: ti.target.value });
                      }}
                      rightElement={passwordButton}
                      intent={
                        this.state.errPwdSpecial ||
                        this.state.errPwdLength ||
                        this.state.errPwdMissmatch
                          ? "danger"
                          : "normal"
                      }
                    />
                  </FormGroup>
                  <FormGroup
                    label={<Trans>new password again</Trans>}
                    labelFor="password-input"
                  >
                    <InputGroup
                      id="password-input"
                      type={this.state.showPassword ? "text" : "password"}
                      onChange={(ti) => {
                        this.setState({ pw2: ti.target.value });
                      }}
                      rightElement={passwordButton}
                      intent={
                        this.state.errPwdSpecial ||
                        this.state.errPwdLength ||
                        this.state.errPwdMissmatch
                          ? "danger"
                          : "normal"
                      }
                    />
                  </FormGroup>
                </form>
                <Callout hidden={!this.state.errPwdMissmatch} intent="danger">
                  <Trans>incorrect password verification</Trans>
                </Callout>
                <Callout hidden={!this.state.errPwdSpecial} intent="danger">
                  <Trans>
                    your new password must contain at least 1 special character
                  </Trans>
                </Callout>
                <Callout hidden={!this.state.errPwdLength} intent="danger">
                  <Trans>
                    your new password must contain at least 8 characters
                  </Trans>
                </Callout>
                <div
                  className={Classes.DIALOG_FOOTER}
                  hidden={!this.state.success}
                >
                  <Callout intent="success">
                    <Trans>password modified successfully</Trans>
                  </Callout>
                </div>
              </Card>

              <Callout hidden={!this.state.errorDelete} intent="danger">
                <Trans>an eror occured, please try again later.</Trans>
              </Callout>
            </div>
            <div className={Classes.DIALOG_FOOTER}>
              <Trans>this operation is irreversible</Trans>
              <div hidden={!this.state.loading}>
                <Spinner />
              </div>
              <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                <Button
                  icon="undo"
                  intent={Intent.DANGER}
                  disabled={this.state.loading}
                  onClick={this.handleClose}
                >
                  <Trans>cancel</Trans>
                </Button>
                {localStorage.getItem("perm_superadmin") === "true" && (
                  <Button
                    loading={this.state.loading}
                    onClick={this.handleChangePassword}
                  >
                    <Trans>send</Trans>
                  </Button>
                )}
              </div>
            </div>
          </Dialog>
        ) : null}

        <Table2
          cellRendererDependencies={[this.state.dataUser]}
          numRows={this.state.dataUser.length}
          rowHeaderCellRenderer={(rowIndex) => (
            <RowHeaderCell
              index={rowIndex}
              name={this.state.dataUser[rowIndex]["id"]}
            />
          )}
        >
          <Column
            id="login"
            cellRenderer={(rowIndex) => (
              <Cell>{this.state.dataUser[rowIndex]["login"]}</Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell name={<Trans>login</Trans>} />
            )}
          />

          <Column
            id="insertiondate"
            cellRenderer={(rowIndex) => (
              <Cell>
                {new Date(
                  this.state.dataUser[rowIndex]["insertiondate"]
                ).toLocaleDateString(i18next.language)}
              </Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell name={<Trans>creation date</Trans>} />
            )}
          />

          {this.state.Columns}

          <Column
            id="permAdmin"
            cellRenderer={(rowIndex) => (
              <Cell>
                {this.state.dataUser[rowIndex]["isAdmin"] ? (
                  <Icon icon="crown" intent="success" />
                ) : (
                  <Icon icon="cross" intent="danger" />
                )}
              </Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell
                name={<Trans>administration permissions</Trans>}
              />
            )}
          />

          <Column
            id="action"
            cellRenderer={(rowIndex) => (
              <Cell>
                <div className="flexbox-center">
                  <Tag
                    icon="key"
                    interactive={true}
                    minimal={true}
                    onClick={() =>
                      this.setState({
                        passwordChange: this.state.dataUser[rowIndex],
                        runningPasswordChange: true,
                      })
                    }
                  />

                  <Tag
                    icon="edit"
                    interactive={true}
                    minimal={true}
                    onClick={() => {
                      this.setState({
                        edit: this.state.dataUser[rowIndex],
                        runningEdit: true,
                      });
                    }}
                  />
                  {localStorage.getItem("perm_superadmin") === "true" &&
                    this.state.dataUser[rowIndex].login !== "thales" && (
                      <Tag
                        icon="trash"
                        intent="danger"
                        minimal={true}
                        interactive={true}
                        onClick={(event, rowData) => {
                          console.log(
                            "DELETE",
                            this.state.dataUser[rowIndex].login
                          );
                          this.setState({
                            delete: this.state.dataUser[rowIndex],
                            runningDelete: true,
                          });
                        }}
                      />
                    )}
                </div>
              </Cell>
            )}
            columnHeaderCellRenderer={() => <ColumnHeaderCell />}
          />
        </Table2>
        <UserCreator isOpen={this.state.createUserRunning} onUpdate={() => { this.updateTable() }} />
        <UserHistory />
      </Callout>
    );
  }
}

export default withTranslation()(UserList);
